import VueCookies from "vue-cookies";

export default function bearerTokenHeader() {
  return { Authorization: `Bearer ${VueCookies.get("authenticate:jwt")}` };
}
